<!--
 * @Description: 设置登录密码
 * @Date: 2021-11-10 13:44:01
-->
<template>
  <div class="user-login__item user-login__setpwd">
    <div class="user-login__sec">设置登录密码</div>
    <div class="user-login__setpwd-info">
      由于您之前的账号未设置登录密码，您将无法使用密码登录
      功能。请您设置登录密码后，您将可以使用密码登录功能。
    </div>
    <LoginForm
      ref="formRef"
      :itemList="itemList"
      :pageType="LoginTypeEnum.SETPWD"
    ></LoginForm>
    <div class="user-login__setpwd-foot">
      <BaseButton @click="onCancel" type="default">取消</BaseButton>
      <BaseButton :click="onLogin">提交</BaseButton>
    </div>
    <div class="user-login__setpwd-skip">
      <BaseButton type="text" :click="onSkip">跳过</BaseButton>
      <span style="line-height: 19px">设置</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { BaseButton } from 'xrk-components';

import { LoginForm } from './login-base/index';
import type { FormRef } from '../types/index';
import { LoginTypeEnum, FormItemEnum } from '../constants/index';

import { setAPassword } from '../data-source/apis';
import { useSetup } from '../store';
import { useEnterpriseRealStoreSetup } from '@/views/enterprise-real/src/store/index';

const itemList = [FormItemEnum.pwd, FormItemEnum.pwd2, FormItemEnum.agreement];

const model = defineModel();

// 表单实例
const formRef = ref<FormRef>(null);

const onCancel = () => {
  model.value = 'login-register';
};
// 跳过设置也算登录
const onSkip = async () => {
  await useSetup().login();

  const storeReal = useEnterpriseRealStoreSetup();
  storeReal.getEntpAuthInfo(data => {
    storeReal.skipNextPage(data.authStep, 'replace');
  });
};

const onLogin = async () => {
  await formRef.value.validate();
  await setAPassword({
    [FormItemEnum.pwd]: formRef.value.data[FormItemEnum.pwd],
    [FormItemEnum.pwd2]: formRef.value.data[FormItemEnum.pwd2],
    authentication: useSetup().info.authentication
  });
  await useSetup().login();
  model.value = 'login-success';
};
</script>

<style scoped lang="scss">
.user-login__setpwd {
  .user-login__setpwd-info {
    font-size: 14px;
    color: #636363;
    line-height: 22px;
    margin-bottom: 32px;
  }

  .user-login__setpwd-foot {
    display: flex;
    align-items: center;
    justify-content: space-between;
    button {
      width: 167px;
      height: 44px;
    }
  }

  .user-login__setpwd-skip {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 14px;
    color: #1a1a1a;
    text-align: right;
    margin-top: 16px;
  }
}
</style>
